module.exports = __webpack_public_path__ + "static/media/download_mobile_app.2c90ee9d.png";